var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon Color",
    d: "M9.58744 0.5C7.97349 0.501758 6.42615 1.14368 5.28491 2.28491C4.14368 3.42615 3.50176 4.97349 3.5 6.58744C3.5 11.4275 8.93774 17.7507 9.16906 18.0185L9.58744 18.5L10.0058 18.0174C10.2371 17.7507 15.6749 11.4275 15.6749 6.58744C15.6749 3.23049 12.9433 0.5 9.58744 0.5ZM9.58744 16.7867C8.31904 15.2106 4.60681 10.2797 4.60681 6.58744C4.60681 3.84145 6.84145 1.60681 9.58744 1.60681C12.3334 1.60681 14.5681 3.84145 14.5681 6.58744C14.5681 10.2764 10.8558 15.2106 9.58744 16.7867ZM9.58744 3.42086C7.75678 3.42086 6.26702 4.91063 6.26702 6.74128C6.26702 8.57194 7.75678 10.0617 9.58744 10.0617C11.4181 10.0617 12.9079 8.57194 12.9079 6.74128C12.9079 4.91063 11.4181 3.42086 9.58744 3.42086ZM9.58744 8.9549C8.36663 8.9549 7.37382 7.96209 7.37382 6.74128C7.37382 5.52048 8.36663 4.52767 9.58744 4.52767C10.8082 4.52767 11.8011 5.52048 11.8011 6.74128C11.8011 7.96209 10.8082 8.9549 9.58744 8.9549Z",
    fill: "#FEFEFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLocation);
export default __webpack_public_path__ + "static/media/white-location.801a343eed77041e481ced6a15b0765d.svg";
export { ForwardRef as ReactComponent };